import * as Utils from './utils';

const body = document.body;
const nav = document.querySelector(".js-nav-container");
let lastScroll = 0;

export function checkScrollPosition() {
  let fill = (Utils.getScrollTop() > 72) ? true : false;
  headerFillTransparency(fill);
}

function checkScrollDirection() {
  const currentScroll = window.pageYOffset;

  if (currentScroll > lastScroll && !nav.classList.contains("scroll-down")) {
    // down
    nav.classList.remove("scroll-up");
    nav.classList.add("scroll-down");
  } else if (currentScroll < lastScroll && nav.classList.contains("scroll-down")) {
    // up
    nav.classList.remove("scroll-down");
    nav.classList.add("scroll-up");
  }
  lastScroll = currentScroll;
}

function headerFillTransparency(fill) {
  nav.classList[fill == true ? 'add' : 'remove']('scroll');
}

window.addEventListener('scroll', () => {
  checkScrollPosition();
  checkScrollDirection();
});

checkScrollPosition();
